import Vue from 'vue'
import Vuex from 'vuex'
import appModule from './app'
import authModule from './auth'
import customerModule from './customer'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		app: appModule,
		auth: authModule,
		customer: customerModule
	}
});
